import { Menu } from '@arco-design/web-react';
import { copyWritingsMap } from './copywritings';
import { useContext } from 'react';
import { LanguageContext, LanguageEnum } from '../../utils';
import { Anchor } from '@arco-design/web-react';

import './index.less';

const AnchorLink = Anchor.Link;
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;

const copyWritings = {
  more: {
    [LanguageEnum.chinese]: '更多示例',
    [LanguageEnum.english]: 'More Examples',
  },
};

const more: Record<string, string> = {
  vchart:
    'https://codesandbox.io/search?refinementList%5Btemplate%5D=&refinementList%5Bnpm_dependencies.dependency%5D%5B0%5D=%40visactor%2Fvchart&page=1&configure%5BhitsPerPage%5D=12',
  vtable:
    'https://codesandbox.io/search?refinementList%5Btemplate%5D=&refinementList%5Bnpm_dependencies.dependency%5D%5B0%5D=%40visactor%2Fvtable&page=1&configure%5BhitsPerPage%5D=12',
  vgrammar:
    'https://codesandbox.io/search?refinementList%5Btemplate%5D=&refinementList%5Bnpm_dependencies.dependency%5D%5B0%5D=%40visactor%2Fvgrammar&page=1&configure%5BhitsPerPage%5D=12',
  vrender:
    'https://codesandbox.io/search?refinementList%5Btemplate%5D=&refinementList%5Bnpm_dependencies.dependency%5D%5B0%5D=%40visactor%2Fvrender&page=1&configure%5BhitsPerPage%5D=12',
};

export function Outline(props: any) {
  const {
    titles,
    contents,
    handleNavContentClick,
    chartGroups,
    siteType,
    demoType,
  } = props;
  const { language, setLanguage, isMobile } = useContext(LanguageContext);
  const groupPath = siteType + `${props.demoType ? `-${props.demoType}` : ''}`;
  const groupCopyWritings = copyWritingsMap[groupPath];

  const moreLinkPath = more[siteType + (demoType ? `-${demoType}` : '')];

  // hack for mobile

  if (siteType === 'vchart') {
    return (
      <div
        className="menu-demo"
        style={{
          height: isMobile ? '100%' : 'calc(100vh - 48px)',
          maxHeight: isMobile ? '100%' : 'calc(100vh - 48px)',
        }}
      >
        <Menu
          style={{
            width: 200,
            height: isMobile ? 'auto' : '100%',
            paddingTop: 20,
            paddingBottom: 20,
          }}
          defaultOpenKeys={['0']}
          defaultSelectedKeys={['0_0']}
          onClickMenuItem={(key) => {
            const keyList = key.split('_');

            const activeIndex = parseInt(keyList[0]);
            const keywordsIndex = parseInt(keyList[1]);

            document
              .getElementById('exampleScrollContainer')
              ?.scrollTo?.({ top: 0 });

            if (activeIndex === 0) {
              handleNavContentClick(0, '');
            } else {
              const keyword = contents[activeIndex - 1][keywordsIndex];
              handleNavContentClick(activeIndex, keyword);
            }
          }}
        >
          {/* <MenuItem key="0">全部图表</MenuItem> */}

          <SubMenu
            key="0"
            title={<>{groupCopyWritings?.allCharts?.[language]}</>}
          >
            <Anchor
              affix={false}
              onSelect={() => {
                handleNavContentClick(0, '');
              }}
              hash={false}
              scrollContainer=".arco-layout-content"
              style={{ maxHeight: '670px' }}
            >
              {(chartGroups ?? []).map((item: string, index: number) => {
                const label =
                  groupCopyWritings?.[item]?.[language] ?? item;
                return (
                  <AnchorLink
                    // style={{
                    //   cursor: 'pointer',
                    //   backgroundColor: 'var(--color-menu-light-bg)',
                    //   color: 'var(--color-text-2)',
                    // }}
                    href={`#${item}`}
                    title={label}
                  >
                    {label}
                  </AnchorLink>
                );
              })}
            </Anchor>
            {/* {(chartGroups ?? []).map((item: string, index: number) => {
              return (
                <MenuItem key={`0_${index}`}>
                  {copyWritings[item] ? copyWritings[item][language] : item}
                  <a href={`#${item}`}></a>
                </MenuItem>
              );
            })} */}
          </SubMenu>
          {(titles ?? []).map((title: string, titleIndex: number) => {
            const titleLabel =
              groupCopyWritings?.[title]?.[language] ?? title;
            return (
              <SubMenu
                key={`${titleIndex + 1}`}
                // title={<>{title}</>}
                title={<>{titleLabel}</>}
                style={{ lineHeight: '24px' }}
              >
                {(contents[titleIndex] ?? []).map(
                  (item: string, index: number) => {
                    const itemLabel =
                      groupCopyWritings?.[item]?.[language] ?? item;
                    return (
                      <MenuItem key={`${titleIndex + 1}_${index}`}>
                        {itemLabel}
                        {/* {keywordsMap[item] ?? item} */}
                      </MenuItem>
                    );
                  }
                )}
              </SubMenu>
            );
          })}
          {moreLinkPath ? (
            <a
              className="visactor-example-filter-outline-more"
              href={moreLinkPath}
              onClick={(event) => {
                event.preventDefault();
                window.open(moreLinkPath);
              }}
            >
              {copyWritings.more[language]}
            </a>
          ) : null}
        </Menu>
      </div>
    );
  } else {
    return (
      <div
        className="menu-demo"
        style={{
          height: isMobile ? '100%' : 'calc(100vh - 48px)',
          maxHeight: isMobile ? '100%' : 'calc(100vh - 48px)',
        }}
      >
        <Menu
          style={{
            width: 200,
            height: isMobile ? 'auto' : '100%',
            paddingTop: 20,
            paddingBottom: 20,
          }}
          defaultSelectedKeys={['0_0']}
          defaultOpenKeys={['0']}
        >
          <SubMenu
            key="0"
            title={
              <>
                {groupCopyWritings?.allCharts?.[language] ??
                  (language === LanguageEnum.chinese ? '全部示例' : 'All Examples')}
              </>
            }
          >
            <Anchor
              affix={false}
              // onSelect={() => {
              //   handleNavContentClick(0, '');
              // }}
              hash={false}
              scrollContainer=".arco-layout-content"
            >
              {(chartGroups ?? []).map((item: string, index: number) => {
                const label =
                  groupCopyWritings?.[item]?.[language] ?? item;
                return (
                  <AnchorLink href={`#${item}`} title={label}>
                    {label}
                  </AnchorLink>
                );
              })}
            </Anchor>
            {/* {(chartGroups ?? []).map((item: string, index: number) => {
              return (
                <MenuItem key={`0_${index}`}>
                  {copyWritings[item] ? copyWritings[item][language] : item}
                  <a href={`#${item}`}></a>
                </MenuItem>
              );
            })} */}
          </SubMenu>
          {moreLinkPath ? (
            <a
              className="visactor-example-filter-outline-more"
              href={moreLinkPath}
              onClick={(event) => {
                event.preventDefault();
                window.open(moreLinkPath);
              }}
            >
              {copyWritings.more[language]}
            </a>
          ) : null}
        </Menu>
      </div>
    );
  }
}
